module.exports = __webpack_public_path__ + "img/20_fineStaff_lyb.139054a3.png";